class VocLogger {
    constructor(app) {
        this.app = app;
        this.path = app.lookup('vocento.config.nibara').path;
        if (this.path === undefined) {
            throw 'nibara path config is empty';
        }
        this.libPath = app.lookup('vocento.config.nibara').libPath;
        if (this.libPath === undefined) {
            throw 'nibara libPath config is empty';
        }
    }

    initialize() {
        if (nibara.nTools.getUrlParam('nibara_debug') === '1') {
            this.app.require([this.path + '/logger.min.js'], (Logger) => {
                /** logger init **/
                Logger.useDefaults();
                let myHandler = Logger.createDefaultHandler({
                    formatter: (messages) => {
                        messages.unshift('nibara_debug::');
                    }
                });
                Logger.setHandler((messages, context) => {
                    myHandler(messages, context);
                });

                /** Change level with require_debug param */
                Logger.setLevel(Logger.WARN);
                if (nibara.nTools.getUrlParam('nibara_debug') === '1') {
                    Logger.setLevel(Logger.DEBUG);
                }

                Logger.debug('Loggger initialized');
                this.app.promised('nibara:logger', Logger);
            });
        } else {
            function debug() {
                /*console.log('[NO-LOGGER]');
                console.log.apply(console, arguments);*/
            }

            var Logger = {
                debug: debug,
                info: debug,
                warn: debug,
                error: debug,
            };

            this.app.promised('nibara:logger', Logger);
        }

    }
}
export default VocLogger;



// WEBPACK FOOTER //
// ./src/VocLogger.js